// extracted by mini-css-extract-plugin
export default {"header":"ZPbk8","headerLeftSide":"CXl6V","headerRightSide":"qCtw8","avatar":"BMUKy"};